import { Button } from '@shared/components/shadcn';
import { HeartGames } from '@shared/icons';
import { twMerge } from '@shared/themes';
import Link from 'next/link';
import { LoginButton } from '../../LoginButton';

type NoGamesProps = {
  title: string;
  paragraph: string;
  buttonText: string;
  buttonHref: string;
  useLoginRedirect?: boolean;
  className?: string;
};

const SHARED_BUTTON_CLASSNAME =
  'w-fit h-10 select-none display-xs-strong text-foreground-subtle-hover bg-button-background-accent hover:bg-button-background-accent-hover transition-colors';

function NoGames(props: NoGamesProps) {
  const { title, paragraph, buttonText, buttonHref, useLoginRedirect, className, ...rest } = props;

  return (
    <div className={twMerge('flex flex-col items-center gap-5', className)}>
      <HeartGames className="w-16 h-16 dark:[&>path:last-child]:fill-foreground" />

      <h4>{title}</h4>

      <p className="paragraph-strong text-foreground-subtle text-center max-w-52">{paragraph}</p>

      {useLoginRedirect ? (
        <LoginButton variant="accent" size="m" className={SHARED_BUTTON_CLASSNAME} data-testid="no-games-login-button" {...rest}>
          {buttonText}
        </LoginButton>
      ) : (
        <Button variant="accent" size="m" className={SHARED_BUTTON_CLASSNAME} asChild>
          <Link href={buttonHref} {...rest}>
            {buttonText}
          </Link>
        </Button>
      )}
    </div>
  );
}

export { NoGames, type NoGamesProps };
